export const didomiConfig = (publicKeyDidomi, productCode) => {
  return {
    cookies: {
      group: {
        enabled: true,
        customDomain: 'spb-' + productCode + '.privacy-center.org', 
      },
    },
    app: {
      apiKey: publicKeyDidomi,
    },
    tagManager: {
      provider: 'gtm',
    },
    integrations: {
      vendors: {
        // Setup the integration with Google (ask Didomi to share consent with Google tags)
        google: {
          enable: true,
          eprivacy: true,
        },
      },
      refreshOnConsent: true, // by default, ads are reloaded after consent is given
    },
  };
};
